import CardCommon from '@op/components/CardCommon';
import { barIcon, lineIcon } from '@op/constants/chart';
import { useTopicLevelTwoTimeline } from '@op/pages/Summary/hooks/useTimelineData';
import React, { useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { expandableLeftChartHeight } from '@op/pages/Summary/constants';
import { LineChart } from '@op/components/ExpandablePlane';

export default function PositiveAndNegative({
  topicLevel,
  filter,
  topics,
  currentTopic,
  sentimentType
}: {
  topicLevel: 'L1' | 'L2';
  filter: any;
  topics: Array<string>;
  currentTopic: string;
  sentimentType: string;
}) {
  const { formatMessage } = useIntl();
  const [chartType, setChartType] = useState('line');

  const params = useMemo(() => ({
    ...filter,
    topic_one_level: [currentTopic],
  }), [filter]);

  const { timelineMap, commonLoading } = useTopicLevelTwoTimeline({
    topic: topics,
    filter: params,
    topicLevel,
    indicatorsType: 'negative_mentions',
  });

  const { timelineMap: positiveTimeLineMap, commonLoading: positiveLoading } =
    useTopicLevelTwoTimeline({
      topic: topics,
      filter: params,
      topicLevel,
      indicatorsType: 'positive_mentions',
    });

  const timeline = useMemo(() => {
    const key = currentTopic || '';
    const { x, y } = timelineMap?.negative_mentions_ratio?.[key] || {};
    const { x: px, y: py } = positiveTimeLineMap?.positive_mentions_ratio?.[key] || {};

    const positiveData = {
      newArr: [{ name: 'Positive%-2', data: py, color: '#69D19C' }],
      timeArr: px || [],
      legendData: [{ name: 'Positive%-2', icon: 'circle', itemStyle: { color: '#69D19C' } }],
    };

    const negativeData = {
      newArr: [{ name: 'Negative%-2', data: y, color: '#F17C86' }],
      timeArr: x || [],
      legendData: [{ name: 'Negative%-2', icon: 'circle', itemStyle: { color: '#F17C86' } }],
    };

    return sentimentType === 'positive' ? positiveData : negativeData;
  }, [timelineMap, positiveTimeLineMap, topics, sentimentType]);

  return (
    <div className="dbo-topic-analysis-chart">
      <CardCommon
        contentCard
        defaultOperation={chartType}
        handleOperationsOnClick={(value: any) => setChartType(value.symbol)}
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {sentimentType === 'positive'
              ? formatMessage({ id: 'Positive%-2' })
              : formatMessage({ id: 'Negative%-2' })}
          </div>
        }
        operations={[lineIcon, barIcon]}
        loading={commonLoading || positiveLoading}
        loadingHeight={expandableLeftChartHeight}
      >
        <LineChart
          chartType={chartType}
          timeline={timeline}
          filter={filter}
          isRatio         
        >
        </LineChart>
      </CardCommon>
    </div>
  );
}
